// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"6aabb986","377":"9763afc8","417":"9a8efa3f","467":"610ecf89","626":"e5e40771","870":"76be9d6e"}[chunkId] + ".js";
};